<template>
  <div class="document-list">
    <v-container fluid>
      <v-row class="documents-pane">
          <!--
          @TODO А их размером можно как-то управлять? А то высота вроде идет на компонент, ширина из css .document-card...
             Условно говоря, если их нужно увеличить, скажем на 50%, то что куда надо писать?
             ---
             задавать высоту
          -->
        <v-progress-linear
            v-if="isLoading"
            :active="isLoading"
            :indeterminate="isLoading"
            absolute
            top
            style="top:2px;"
            color="primary"
        ></v-progress-linear>
        <document-preview v-else v-for="document in documentList"
            :value="document"
            :key="document.id"
            :image="`${projectUrl}${document.id}/thumbnail/`"
            :image-height="previewImageHeight"
            :contain="false"
            @action="onPreviewAction"
        ></document-preview>
        <document-preview
            v-if="canCreate && !isLoading"
            :image="false"
            :image-height="previewImageHeight"
            :contain="false"
            top-color="white"
            static-title="Добавить документ"
            class="add-document"
            :style="{'--blank-card-height': previewImageHeight + 'px'}"
        >
          <v-btn 
              class="mx-2" fab dark 
              color="primary" 
              @click="onCreateDocumentClick"
          ><v-icon dark>{{ icons.mdiPlusCircle }}</v-icon></v-btn>
        </document-preview>
      </v-row>
    </v-container>
    <document-settings 
        v-model="selectedDocument" 
        :key="componentsKeys.documentSettings"  
        :draggable="false" 
        :projectId="projectId"  
        @save="onDocumentUpdate"
        @create="onDocumentCreated"
        ref="documentSettings"
      ></document-settings>
    
    <v-dialog-confirm
        ref="confirm"
        type="confirm"
        @confirm="e => e"
        v-slot="{data}"
    >
        <v-container class="pa-0">
            <v-row no-gutters>
                <v-col>
                    Вы действительно хотите удалить документ {{data.id}}?
                </v-col>
            </v-row>
        </v-container>
    </v-dialog-confirm>
  </div>
</template>

<script>
import { mdiPlusCircle } from '@mdi/js';
import UserAuth from "@/mixins/UserAuth";
import ComponentsKeys from "@/mixins/ComponentsKeys";
export default {
  name: "ProjectDocumentsPage",
  components: {
    DocumentPreview: () => import('@/components/Document/DocumentPreview'),
    DocumentSettings: () => import('@/components/Document/DocumentSettings'),
    VDialogConfirm: () => import('@/components/commonComponents/VDialogConfirm'),
  },
  mixins: [
    UserAuth,
    ComponentsKeys,
  ],
  props: {
    id: [String, Number],
    openDocumentAsPage: {
      type: Boolean,
      default: true
    },
  },
  data: () => ({
    notifyOptions: {
      title: 'Список документов',
    },
    documentList: [],
    permissions: {},
    icons: {
      mdiPlusCircle,
    },
    previewImageHeight: 322, 
    isLoading: false,
    defaultDocument: {
      name: "",
      css: "",
      immutable_css: "",
      padding_top: '6',
      padding_bottom: '6',
      padding_left: '21',
      padding_right: '21',
      primary_color: "#000000FF",
      secondary_color: "#000000FF",
      date_start: '',
    },
    selectedDocument: {},
  }),
  computed: {
    projectId() {
      return this.id || this.$route.params.project;
    },
    projectUrl() {
      return this.$apiUrl.getFullUrl(`/api/${this.projectId}/report/`);
    },
    canCreate() {
      return this.permissions.canCreate && this.user?.permissions?.byModule?.pdf?.canCreate;
    },
  },
  created() {
    this.loadDocumentList();
    this.updateComponentKey('documentSettings');
  },
  methods: {
    downloadFile(data, filename, type) {
      var file = new Blob([data], {
        type: type,
      });
      if (window.navigator.msSaveOrOpenBlob)
        // IE10+
        window.navigator.msSaveOrOpenBlob(file, filename);
      else {
        // Others
        var a = document.createElement('a'),
          url = URL.createObjectURL(file);
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        setTimeout(async () => {
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }, 0);
      }
    },
    getDocumentById(id) {
      return this._.find(this.documentList, {id});
    },
    getDocumentIndexById(id) {
      return this._.findIndex(this.documentList, {id});
    },
    loadDocumentList() {
      this.isLoading = true;
      this.$api.get(this.projectUrl).then(resp => {
        this.notifySuccess(`Список документов успешно загружен`);
        this.documentList = resp?.data?.data || [];
        this.permissions = resp?.data?.meta?.permissions || {};
      }).catch(this.notifyError).finally(() => {
        this.isLoading = false;
      });
    },
    deleteAction(id) {
      this.$refs.confirm.show({id})
        .then((result) => {
            if (result) {                  
              const index = this.getDocumentIndexById(id);
              this.documentList.splice(index, 1);  
              this.isLoading = true;
              this.$api.delete(this.projectUrl + id).then(() => {
                this.loadDocumentList();
                this.notifySuccess(`Документ ${id} успешно удален`);
              }).catch(this.notifyError).finally(() => {
                this.isLoading = false;
              });
            }
        })
        .catch(this.notifyError)
    },
    settingsAction(id, doc) {
      this.$refs.documentSettings.show(id, doc).then(data => {
        /**
         * Сработает только при сохранении, при "отмене" в data будет undefined
         */
        if(data?.id) {
          this.onPreviewAction(['edit', data.id]);
          return;
        }
        this.loadDocumentList();
      })
      .finally(() => {
          this.updateComponentKey('documentSettings');
      });
    },
    editAction(id) {
      this.$emit('open-document', {projectId: this.projectId, id});
      if (this.openDocumentAsPage) {
        this.$router.push(`/document-editor/${this.projectId}/${id}`);
      }
    },
    exportAction(id) {
      this.isLoading = true;
      const document = this.getDocumentById(id);
      return this.$api.request({
          url: this.projectUrl + `${id}/download/`,
          method: 'GET',
          responseType: 'blob'
      }).then(response => {
        this.notifySuccess(`Файл ${document.name}.pdf успешно сформирован`);
        this.downloadFile(
          response.data,
          document.name + '.pdf',
          'application/pdf',
        );
      }).catch(this.notifyError).finally(() => {
        this.isLoading = false;
      });
    },
    onPreviewAction([action, id]) {
      if(typeof this[action + 'Action'] === 'function')  {
        this[action + 'Action'](id);
      }
    },
    onDocumentCreated(/* data */) {
      this.loadDocumentList();
    },
    onDocumentUpdate(/* data */) {
      this.loadDocumentList();
    },
    onCreateDocumentClick() {
      this.settingsAction(0, this._.cloneDeep(this.defaultDocument));
    },
  },
};
</script>
<style lang="scss" scoped>
  .document-list {
    height: 100%;
    position: relative;
    
    .v-image__image, 
    .v-image__placeholder {
      top: 0;
      left: 0;
      bottom: 0;
      right: 0;
      width: auto;
      height: auto;
      transition: 0.3s all ease-out;
    }
    
    .document-card {
      &:hover {
        .v-image__image, 
        .v-image__placeholder {
          top: -15px;
          left: -15px;
          bottom: -15px;
          right: -15px;
        }
      }
    }
    .documents-pane {
      padding: 20px;
      gap: 20px;
    }
    ::v-deep .add-document { 
      .v-toolbar__content {
        border-bottom: 1px solid #eee;
      }
      .v-card__text {
        height: var(--blank-card-height);
        display: flex;
        align-items: center;
        justify-content: center;
        .v-btn {
          margin: 40px 20px;
        }
      }
    }
  }
</style>
